import ClearIcon from "~icons/fa6-solid/x";
import Button from "@/lib/Button";
import { useAddNote } from "@/lib/queries/hooks";
import { useState } from "react";
import { useParams } from "react-router";

export default function AddNote({ done }: { done: () => void }) {
  const addNote = useAddNote();
  const [input, setInput] = useState("");
  const { rfqId } = useParams();

  return (
    <div className="w-[700px] h-[500px] flex flex-col justify-between gap-4 p-4">
      <div className="h-8 flex justify-between">
        <div className="font-bold">Add Note</div>
        <ClearIcon
          className="cursor-pointer text-slate-400 hover:text-slate-600 size-3"
          onClick={done}
        />
      </div>
      <textarea
        placeholder="Enter text"
        className="border rounded-sm p-3"
        autoFocus
        rows={10}
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />
      <div className="flex justify-end gap-2 h-8">
        <Button onClick={done}>Cancel</Button>
        <Button
          primary
          disabled={!input}
          onClick={() =>
            addNote({ rfqId: rfqId!, content: input }, { onSuccess: done })
          }
        >
          Save
        </Button>
      </div>
    </div>
  );
}
